import { Trans } from "@lingui/react/macro";
import { HeartIcon } from "lucide-react";
import { useId } from "react";

// «Pro — это поддержка проекта»: платежи помогают развитию, всё новое войдёт в Pro без доплаты.
export const SupportNote = () => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className="flex items-center gap-4 rounded-xl border border-border bg-surface px-5 py-4.5"
    >
      <span className="inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-sidebar-active text-accent">
        <HeartIcon aria-hidden="true" className="size-5.5" />
      </span>
      <span className="flex flex-col gap-0.5">
        <h2 id={headingId} className="font-display text-[22px] leading-tight">
          <Trans>Pro supports the project</Trans>
        </h2>
        <span className="text-sm text-muted">
          <Trans>
            Your subscription helps Relock grow. We are grateful to every one of you, and everything
            new we build will be part of Pro at no extra charge.
          </Trans>
        </span>
      </span>
    </section>
  );
};
